export function downloadUd(streamUrl) {
  const link = document.createElement("a");
  link.href = streamUrl;
  link.download = ""; // 서버 Content-Disposition 사용
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function DownloadUdFile({ streamUrl, t }) {
  return (
    <button className="btn-bg-blue" onClick={() => downloadUd(streamUrl)}>
      {t("imageFileIndex.buttons.udFileDownload")}
    </button>
  );
}
